import {useEffect, useState, ReactNode} from 'react';
import Home from './Home';

type RouteParams = {
  path: string;
  component: ReactNode;
}

interface TestAppProps {
  routes: RouteParams[];
}

const defaultRoute = {path: "/", component: <Home/>};

const MegaSimpleRouter = ({routes}: TestAppProps) => {
  const [route, setRoute] = useState<RouteParams>(defaultRoute);

  useEffect(() => {
    const [selectedRoute] = routes.filter((route) => route.path === window.location.pathname);
    if (selectedRoute) {
      setRoute(selectedRoute);
    } else {
      setRoute(defaultRoute);
    }
  },  [window.location.pathname]);

  return route.component;
}

export default MegaSimpleRouter;